<template>
  <div class="home">
    <div class="header"  v-if="$route.meta.alive">
      <Header></Header>
    </div>
    <div class="main">
      <Main ref="main"></Main>
    </div>
    <div class="footer"  v-if="$route.meta.alive">
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from '@/components/m/Header.vue';
import Main from '@/components/m/Main.vue';
import Footer from '@/components/m/Footer.vue';

export default {
  name: 'Home',
  mounted() {
  },
  watch: {},
  data() {
    return {
      header: false,
    };
  },
  methods: {
    handleScroll() {
      const scrollTop = window.pageYOffset
        || document.documentElement.scrollTop
        || document.body.scrollTop;
      if (scrollTop > 30) {
        this.header = true;
      } else {
        this.header = false;
      }
    },
  },
  components: {
    Header,
    Main,
    Footer,
  },
};
</script>

<style lang="less">

  .fix {
    position: fixed !important;
    top: 0 !important;

    left: 0 !important;
  }
  .home {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    background: #fff;
  }
  Header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 99;
  }
  .header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 99;
  }
  .bg {
    background: #231f38;
  }
  .Main {
    width: 100%;
  }
  .Footer {
    width: 100%;
    display: flex;
    justify-content: center;
    background-color: #01192e;
  }
</style>
